import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText } from '../../../../utils';
import { ChangeContactView } from '../../components/ChangeContactView';
import EditableInput from '../../components/EditableInput';
import './style.scss';
import { goto } from '../../../../actions/historyActions';
import {
  getChangeMobileLabels,
  getChangeMobileStepContext,
  getNewMobile,
  getCountryCode,
  getIsLoading,
  getForm,
} from '../../selectors/updateMobileSelector';
import {
  sendChangeMobileOtpRequest,
  updateFormStates,
} from '../../actions/changeMobileAction';
import { getSelectedList } from '../../selectors/updateMobileSelector';
import {
  getChangeContactPolicyCardsLength,
  getSelectedPolicy,
} from '../../selectors/changeContactSelector';
import { contactPermissionPolicy } from '../../types/changeContactService';
import { sortPermissionPolicies } from '../../utils';
import _ from 'lodash';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import LongLoadingView from '../../../../components/LongLoadingView';
import { POLICIES } from '../../constants/constants';
import { ENTITY_CODE } from '../../../../constants/constants';
import { passPath } from '../../../../utils/emmaUrlConverter';
import {
  trackPartnerServiceDisclaimer,
  TrackPartnerServiceDisclaimerIcon,
} from '../../../../utils/generalGaEventAnalytics';
import { EmmaCheckbox } from '@axa-asia/emma-stylesheet';

interface Form {
  notify: boolean | null;
  useOfData: boolean | null;
  providedValidData: boolean | null;
  agreeRevokeSms: boolean | null;
}

export interface ReviewMobileContainerProps {
  changeMobileLabels: any;
  changeMobileStepContext: any;
  newMobileNum: string;
  countryCode: string;
  selectedPolicy: any;
  selectedList: contactPermissionPolicy[];
  onSubmitChangeMobileForm: () => void;
  isLoading: boolean;
  form: Form;
  onUpdateFormStates: (payload: any) => void;
  policies: number;
}

export interface ReviewMobileContainerState {
  isFormValid: boolean;
}

export class ReviewMobileContainer extends Component<
  ReviewMobileContainerProps,
  ReviewMobileContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isFormValid: false,
    };
  }

  componentDidMount() {
    const { newMobileNum, selectedPolicy } = this.props;

    if (!newMobileNum || _.isEmpty(selectedPolicy)) {
      goto('emma-change-contact', undefined, undefined, true);
      return;
    }
    this.validateForm();
  }

  componentDidUpdate(prevProps: Readonly<ReviewMobileContainerProps>): void {
    if (this.props.form !== prevProps.form) {
      this.validateForm();
    }
  }

  validateForm() {
    const { selectedPolicy, form } = this.props;
    const isFormValid = Object.keys(form)
      .filter((k) =>
        selectedPolicy.suspensionFlagSms === 'S'
          ? true
          : k !== 'agreeRevokeSms',
      )
      .every((key: keyof Form) => key === 'notify' || form[key]);
    this.setState({ isFormValid });
  }

  onSubmit = () => {
    const { onSubmitChangeMobileForm } = this.props;

    trackPartnerServiceDisclaimer(
      TrackPartnerServiceDisclaimerIcon.CONTACT_UPDATE,
    );

    onSubmitChangeMobileForm();
  };

  render() {
    const {
      changeMobileLabels,
      changeMobileStepContext,
      newMobileNum,
      countryCode,
      isLoading,
      selectedPolicy,
      selectedList,
      form,
      onUpdateFormStates,
      policies,
    } = this.props;
    const { isFormValid } = this.state;
    const {
      editMobileTitle,
      reviewMobileHeading,
      reviewMobileLabel,
      reviewPolicies,
      agreeNotification,
      agreeUseOfData,
      agreeProvidedValidData,
      agreeRevokeSmsLabel,
      yes,
      verifyBtn,
    } = changeMobileLabels;
    const { notify, useOfData, providedValidData, agreeRevokeSms } = form;
    const resolvedStepContext = resolveLocalizedText(
      changeMobileStepContext,
    ) as any;
    const reviewMobileEbAlert = changeMobileLabels.reviewMobileEbAlert
      ? resolveLocalizedText(changeMobileLabels.reviewMobileEbAlert)
      : '';
    const hasEB = [selectedPolicy, ...selectedList].some(
      (policy) => policy.entityCode === ENTITY_CODE.EHK,
    );

    return (
      <div className="review-mobile">
        <ChangeContactView
          pageName={
            editMobileTitle ? resolveLocalizedText(editMobileTitle) : ''
          }
          stepContext={resolvedStepContext}
          activeIndex={1}
        >
          {isLoading ? (
            <LongLoadingView isShowText={policies > POLICIES} />
          ) : (
            <div className="emma-stylesheet-grid-system">
              <div className="change-contact-heading2">
                {reviewMobileHeading
                  ? resolveLocalizedText(reviewMobileHeading)
                  : ''}
              </div>
              <div className="review-mobile__editable-input">
                <EditableInput
                  label={
                    reviewMobileLabel
                      ? resolveLocalizedText(reviewMobileLabel)
                      : ''
                  }
                  id="reviewEmailLabel"
                  value={`(${countryCode}) ${newMobileNum}`}
                  disabled
                  onClickIcon={() => {
                    // const backIndex = getHistoryIndexById(CHANGE_MOBILE_EDIT_ID);
                    // historyGo(backIndex);
                    goto(
                      passPath(
                        'emma-customer-profile/changemobile',
                        '/renewalupdate',
                      ),
                    );
                  }}
                />
                {hasEB && (
                  <div className="change-contact-text change-contact-text--light">
                    {reviewMobileEbAlert}
                  </div>
                )}
              </div>
              <div className="change-contact-label">
                {reviewPolicies ? resolveLocalizedText(reviewPolicies) : ''}
              </div>
              <div className="change-contact-label">
                <ul>
                  {sortPermissionPolicies([
                    selectedPolicy,
                    ...selectedList,
                  ]).map(({ policyName, planName }, index) => {
                    return (
                      <li key={`policy-${index}`}>
                        {resolveLocalizedText(planName || policyName || '')}
                      </li>
                    );
                  })}
                </ul>
              </div>
              <div className="review-mobile-disclaimer row">
                <div className="col-12">
                  <div className="row">
                    <EmmaCheckbox
                      content={
                        <div
                          className="review-mobile-disclaimer-title col-12 change-contact-text"
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(
                              agreeUseOfData
                                ? resolveLocalizedText(agreeUseOfData)
                                : '',
                            ),
                          }}
                        ></div>
                      }
                      checked={useOfData}
                      onChange={(checked) =>
                        onUpdateFormStates({ useOfData: checked })
                      }
                      gaText={yes ? resolveLocalizedText(yes) : ''}
                    ></EmmaCheckbox>
                  </div>
                </div>
              </div>
              <div className="review-mobile-disclaimer row">
                <div className="col-12">
                  <div className="row">
                    <EmmaCheckbox
                      content={
                        <div
                          className="review-mobile-disclaimer-title col-12 change-contact-text"
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(
                              agreeNotification
                                ? resolveLocalizedText(agreeNotification)
                                : '',
                            ),
                          }}
                        ></div>
                      }
                      checked={notify}
                      onChange={(checked) =>
                        onUpdateFormStates({ notify: checked })
                      }
                      gaText={yes ? resolveLocalizedText(yes) : ''}
                    ></EmmaCheckbox>
                  </div>
                </div>
              </div>
              <div className="review-mobile-disclaimer row">
                <div className="col-12">
                  <div className="row">
                    <EmmaCheckbox
                      content={
                        <div
                          className="review-mobile-disclaimer-title col-12 change-contact-text"
                          dangerouslySetInnerHTML={{
                            __html: memoSanitize(
                              agreeProvidedValidData
                                ? resolveLocalizedText(agreeProvidedValidData)
                                : '',
                            ),
                          }}
                        ></div>
                      }
                      checked={providedValidData}
                      onChange={(checked) =>
                        onUpdateFormStates({ providedValidData: checked })
                      }
                      gaText={yes ? resolveLocalizedText(yes) : ''}
                    ></EmmaCheckbox>
                  </div>
                </div>
              </div>
              {selectedPolicy.suspensionFlagSms === 'S' && (
                <div className="review-mobile-disclaimer row">
                  <div className="col-12">
                    <div className="row">
                      <EmmaCheckbox
                        content={
                          <div
                            className="review-mobile-disclaimer-title col-12 change-contact-text"
                            dangerouslySetInnerHTML={{
                              __html: memoSanitize(
                                agreeRevokeSmsLabel
                                  ? resolveLocalizedText(agreeRevokeSmsLabel)
                                  : '',
                              ),
                            }}
                          ></div>
                        }
                        checked={agreeRevokeSms}
                        onChange={(checked) =>
                          onUpdateFormStates({ agreeRevokeSms: checked })
                        }
                        gaText={yes ? resolveLocalizedText(yes) : ''}
                      ></EmmaCheckbox>
                    </div>
                  </div>
                </div>
              )}

              <div className="row">
                <button
                  className={`review-mobile-button ${
                    isFormValid
                      ? 'emma-stylesheet-primary-default-button'
                      : 'emma-stylesheet-primary-secondary-default-disabled-button'
                  }`}
                  data-enable-ga
                  data-ga-type="button"
                  onClick={this.onSubmit}
                  disabled={!isFormValid}
                >
                  {verifyBtn ? resolveLocalizedText(verifyBtn) : ''}
                </button>
              </div>
            </div>
          )}
        </ChangeContactView>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeMobileLabels = getChangeMobileLabels(state);
    const changeMobileStepContext = getChangeMobileStepContext(state);
    const newMobile = getNewMobile(state);
    const countryCode = getCountryCode(state);
    const selectedList = getSelectedList(state);
    const selectedPolicy = getSelectedPolicy(state);
    const isLoading = getIsLoading(state);
    const form = getForm(state);
    const policies = getChangeContactPolicyCardsLength(state);

    return {
      changeMobileLabels,
      changeMobileStepContext,
      newMobileNum: newMobile,
      countryCode,
      selectedList,
      selectedPolicy,
      isLoading,
      form,
      policies,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {
      onUpdateFormStates: (payload: any) => dispatch(updateFormStates(payload)),
      onSubmitChangeMobileForm: () => dispatch(sendChangeMobileOtpRequest()),
    };
  }
}

export default connect(
  ReviewMobileContainer.mapStateToProps,
  ReviewMobileContainer.mapDispatchToProps,
)(ReviewMobileContainer);
